import { render, staticRenderFns } from "./guarantee.vue?vue&type=template&id=5b32a148&scoped=true&"
import script from "./guarantee.vue?vue&type=script&lang=js&"
export * from "./guarantee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b32a148",
  null
  
)

export default component.exports